import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';
import { Container, Typography, Stack, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import BrandLogo from '../../components/BrandLogo';
import { supabase } from '../../supabaseClient.js';
import CircularProgress from '@mui/material/CircularProgress';

const UserInvite = () => {
  const [userMetadata, setUserMetadata] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    await setupAccount();
    setLoading(false);
  };

  const setupAccount = async () => {
    const { data: { user }, error } = await supabase.auth.getUser();
    if (error) {
      console.error('Error fetching user: ', error.message);
    }
    if(!user){
      navigate('/login');
    } else if(!user.user_metadata.hasOwnProperty('teamName')) {
      navigate('/users');
    } else {
      setUserMetadata(user.user_metadata);
    }
  };
  
  return (
    <Container disableGutters maxWidth={false}> 
      <Grid container spacing={2} sx={{ minHeight: '100vh', minWidth: '100vw' }}>
        <Grid size={12} sx={{ backgroundColor: '#B9F4F2', height: '90px', padding: '15px 10px 0px', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
            <BrandLogo  />
        </Grid>
        <Grid size={12} sx={{display: 'flex', alignItems: 'flex-start', justifyContent: 'center'}}>
          {
            !loading && userMetadata ? (
            <Stack spacing={3} width={{xs: '80vw', md: '40vw'}} direction="column" alignItems="flex-start" justifyContent="center" style={{backgroundColor: '#f5f5f5', padding: '30px', borderRadius: '10px', boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)' }}>
              <Typography variant="h6" sx={{fontWeight: 'bold', fontSize: '30px'}}>You have accepted the invite to join the team <b>{userMetadata.teamName}</b> on Tikcare. Please click <span onClick={() => { navigate('/signup', {state: {userMetadata} }) }} style={{ cursor: 'pointer', color: '#29C0BB' }}>here</span> to complete the signup process and view your team.</Typography> 
            </Stack>
            ) : (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
              <CircularProgress size={24} />
            </Box> )
          }
        </Grid> 
      </Grid>
    </Container>
  );
};

export default UserInvite;

